import { withTranslation } from "i18n";
import { useRouter } from "next/router";
import React from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BiBook } from "react-icons/bi";
import { MdDateRange, MdSubject } from "react-icons/md";
import {
  assessmentResultString,
  assessmentString,
  stringFiles
} from "res/strings";

function ResultCard({
  t,
  title,
  description,
  present,
  duration,
  courses,
  startAtPersian,
  isEndedExam,
  endAtPersian,
  id,
  subject,
  isShowResponseForParent,
  isFinishedExam,
  statusAssignmentName,
}) {
  const router = useRouter();
  const courseNames = courses.map((course) => course.name);


  return (
    <Card
      className="my-2"
      onClick={() =>
        present &&
        isFinishedExam &&
        router.push(
          `/assignment/[assignmentID]/Result`,
          `/assignment/${id}/Result`
        )
      }
    >
      <Card.Body>
        <div className="d-flex">
          <p className="w-100 m-0 text-left text-primary app-text-md">{title}</p>
        </div>

        <RowItem value={subject} label={t(assessmentString.subject)} >

        <MdSubject className="mx-1 text-primary"/>

        </RowItem>

       

       {courses.length > 0 && 
       <RowItem
          value={courseNames.toString()}
          label={t(assessmentString.courseName)}
        >

              <BiBook className="mx-1 text-primary"/>
          
          </RowItem>
          }

        {description && (
          <RowItem
            value={description}
            label={t(assessmentString.description)}
          >

            <AiOutlineInfoCircle className="mx-1 text-primary"/>

            </RowItem>
        )}

        <RowItem value={endAtPersian} label={t(assessmentString.endAt)} >

          <MdDateRange className="mx-1 text-primary"/>
          </RowItem>

        <RowItem value={startAtPersian} label={t(assessmentString.startAt)} >

        <MdDateRange className="mx-1 text-primary"/>

          </RowItem>


          {(present && isFinishedExam && statusAssignmentName) && <Badge variant="primary" className="align-items-center">وضعیت تصحیح : {statusAssignmentName}</Badge>}


          {present && !isFinishedExam &&  <Badge variant="warning" className="text-white">
            {t(assessmentResultString.assessmentNotSend)}
          </Badge>}


        {!present && (
          <Badge variant="warning" className="text-white">
            {t(assessmentResultString.assessmentNotJoin)}
          </Badge>
        )}

      </Card.Body>

      {(present && isFinishedExam) && (
        <Card.Footer className="d-flex text-primary">
          {t(assessmentResultString.viewResult)}
        </Card.Footer>
      )}

    </Card>
  );
}

const RowItem = ({ label, value ,children}) => {
  return (
    <Row className="my-1">
      <Col className="d-flex p-0 m-0 text-left align-items-center" xs={4}>
      {children}
        {label && <p className="m-0 text-secondary">{label}</p>}
      </Col>
      <Col className="d-flex p-0 m-0" xs={8}>
        <p className="text-left m-0">{value}</p>
      </Col>
    </Row>
  );
};
export default withTranslation(stringFiles.common)(ResultCard);
